module.exports = __webpack_public_path__ + "static/media/FlagUK.2e9c71c7.svg";